import { importDataActions } from '../../store/reducers/importDataSlice';
import { notificationActions } from '../reducers/notificationSlice';
import { ROUTES } from '../../config/routes';
import { DATA_IMPORT_TYPES } from '../../pages/admin/import/common';
import { APIConfig } from '../../utils/apiUtils';
import api from "../../api/index";
import { showDialog } from '../reducers/dialogSlice';
import { getErrorMessage } from './errorHandler'; // optional helper
import ExcelJS from 'exceljs';

const rootUrl = process.env.REACT_APP_API_ROOT_URL;

export const importData = (files: File[], type: string | null) => {
	return async (dispatch: any) => {
		let postURL = '';
		let sourcePageURL = '';

		if (type === DATA_IMPORT_TYPES.rack) {
			postURL = APIConfig.getRackImportData();
			sourcePageURL = ROUTES['importRack'].url;
		}
		if (type === DATA_IMPORT_TYPES.switch) {
			postURL = APIConfig.getSwitchImportData();
			sourcePageURL = ROUTES['importSwitch'].url;
		}
		if (type === DATA_IMPORT_TYPES.labInventory) {
			postURL = APIConfig.getLabInventoryImportData();
			sourcePageURL = ROUTES['importLabInventoryInfo'].url;
		}

		try {
			const formData = new FormData();
			files.forEach((file) => formData.append('files', file));

			const response = await api.post(`${rootUrl}/${postURL}`, formData);
			const responseData: IResponseConfig | undefined = response.data;

			if (response && response.status === 200 && responseData?.isSuccess) {
				dispatch(
					notificationActions.showNotification({
						isVisible: true,
						notificationDetails: [
							{
								type: 'success',
								message: responseData?.message[0] || 'Import successful',
								sourcePageURL,
								data: [],
							},
						],
					})
				);
			} else {
				const errMsg =
					responseData?.message && Array.isArray(responseData.message) && responseData.message.length > 0
						? responseData.message.join(', ')
						: 'Problem occurred while importing data.';

				dispatch(
					showDialog({
						message: errMsg,
						confirmAction: 'RELOAD_PAGE',
					})
				);
			}
		} catch (error: any) {
			const message =
				error?.response?.data?.message ||
				getErrorMessage(error, 'Data Import', 'import');

			dispatch(
				showDialog({
					message,
					confirmAction: 'RELOAD_PAGE',
					visible: true,
				})
			);
		} finally {
			dispatch(
				importDataActions.resetLoading({
					isLoading: false,
					isSuccess: false,
				})
			);
		}
	};
};
